import React from 'react';

const STEPS = [
    { t: 'Free eligibility check', d: '10 minutes. No commitment. Confirm you qualify before spending anything.' },
    { t: 'Connect your documents', d: 'Drive, SharePoint, Dropbox or direct upload. One connection, all 17 sections.' },
    { t: 'AI auto-fills ~60%', d: 'Clarence pre-populates from your docs. Your team reviews and certifies every answer.' },
    { t: 'Analyser reviews all 17 CDs', d: 'AI flags gaps and inconsistencies against FCA standards — before anyone else sees them.' },
    { t: 'Director sign-off & submit', d: 'Certify inside the module. Operator gets a structured admission file. Window opens.' },
];

const PiscesHowItWorks = () => (
    <section id="how-it-works" className="lp-steps5-sec">
        <div className="lp-prob-head">
            <div className="lp-eyebrow" data-lp-reveal><span className="lp-ww-eyebrow">How it works</span></div>
            <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ fontSize: '35px', maxWidth: '1200px' }}>From eligibility check to window-ready — in days.</h2>
        </div>
        <div className="lp-steps5">
            <div className="lp-steps5-line" aria-hidden="true" />
            {STEPS.map((s, i) => (
                <div className="lp-step5" key={i} data-lp-reveal data-lp-delay={i * 100}>
                    <div className="no">{i + 1}</div>
                    <h3>{s.t}</h3>
                    <p>{s.d}</p>
                </div>
            ))}
        </div>
    </section>
);

export default PiscesHowItWorks;
